"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerContentCircle = void 0;
var react_1 = __importDefault(require("react"));
var inner_content_circle_styles_1 = require("./inner_content_circle.styles");
var CircleSizeMap = new Map([
    ['xs', 'shrink-3'],
    ['sm', 'shrink-1'],
    ['lg', 'grow-5'],
    ['2x', 'grow-15'],
    ['3x', 'grow-30'],
    ['5x', 'grow-60'],
    ['7x', 'grow-95'],
]);
var CircleContentSizeMap = new Map([
    ['mini', 'shrink-7'],
    ['small', 'shrink-4'],
    ['base', 'shrink-3'],
    ['medium', 'grow-1'],
    ['large', 'grow-5'],
    ['extraLarge', 'grow-12'],
]);
var InnerContentCircle = function (props) {
    var contentInCircle = props.contentInCircle, circleContentSizeTag = props.circleContentSizeTag, circleContentColor = props.circleContentColor, circleContentFontWeight = props.circleContentFontWeight, circleSizeTag = props.circleSizeTag, backgroundColor = props.backgroundColor, borderColor = props.borderColor, borderSize = props.borderSize;
    return (react_1.default.createElement(inner_content_circle_styles_1.StyledCircle, { className: "fa-layers fa-fw", backgroundColor: backgroundColor, borderColor: borderColor, borderSize: borderSize },
        react_1.default.createElement("i", { className: "fas fa-circle", "data-fa-transform": CircleSizeMap.get(circleSizeTag) }),
        react_1.default.createElement(inner_content_circle_styles_1.StyledCircleContent, { className: "fa-layers-text", "data-fa-transform": CircleContentSizeMap.get(circleContentSizeTag), circleContentColor: circleContentColor, circleContentFontWeight: circleContentFontWeight }, contentInCircle)));
};
exports.InnerContentCircle = InnerContentCircle;
